<template>
  <div class="event-container">
    <div class="top-option-container">
      <div class="server-container">
        <div class="label-server">
          <label>Company Group</label>
        </div>
        <b-form-select
          :options="[
            { value: 'ALL', text: 'ALL' },
            { value: 'BERAU', text: 'BCE' },
            { value: 'GEMS', text: 'GEMS' },
          ]"
          v-model="server"
          class="list-menu"
        ></b-form-select>
      </div>
      <b-form class="datepicker-form-container">
        <div class="label-period">
          <label>Period</label>
        </div>
        <div class="datepicker-container">
          <datepicker
            :bootstrap-styling="true"
            :value="periodFrom"
            :format="format"
            @selected="selectFrom"
            placeholder="From"
            calendar-class="datepicker-el"
            input-class="datepicker-input"
          ></datepicker>
        </div>
      </b-form>
      <b-form class="datepicker-form-container">
        <div class="label-period">
          <label>To</label>
        </div>
        <div class="datepicker-container">
          <datepicker
            :bootstrap-styling="true"
            :value="periodTo"
            :format="format"
            @selected="selectTo"
            placeholder="To"
            calendar-class="datepicker-el"
            input-class="datepicker-input"
          ></datepicker>
        </div>
      </b-form>
    </div>
    <div class="bottom-option-container">
      <div class="top-list-container">
        <div class="label-top-list">
          <label>Top List</label>
        </div>
        <b-form-select
          :options="[
            { value: null, text: 'All Event' },
            { value: 10, text: '10' },
            { value: 15, text: '15' },
            { value: 20, text: '20' },
          ]"
          v-model="topList"
          class="top-list-menu"
        ></b-form-select>
      </div>
      <b-button @click="getEventData">
        Submit
      </b-button>
    </div>
    <div class="table-container">
      <b-table
        striped
        responsives
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :per-page="topList"
      >
        <!-- <template v-slot:table-colgroup>
			    <col
			      v-for="field in fields"
			      :key="field.key"
			      :style="{ width: widthHeadTable(field.key) }"
			    >
			  </template> -->
      </b-table>
    </div>
    <div class="loading-dashboard" v-if="isLoading">
      <b-spinner
        variant="primary"
        label="Spinning"
        class="loading-spinner"
      ></b-spinner>
    </div>
  </div>
</template>
<script>
import { api } from '../services/config'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
export default {
  name: 'eventDashboard',
  components: {
    Datepicker,
  },
  data() {
    return {
      isLoading: false,
      sortBy: 'EVENT_COUNT',
      sortDesc: true,
      format: 'd MMM yyyy',
      periodFrom: `${moment()
        .subtract(30, 'days')
        .format('YYYY-MM-DD')}`,
      periodTo: `${moment(new Date()).format('YYYY-MM-DD')}`,
      server: 'ALL',
      serverOption: ['BERAU', 'BCE', 'GEMS', 'ALL'],
      topList: null,
      items: [],
      fields: [
        { key: 'SERVER', label: 'Server', sortable: false, thClass: 'bg-head' },
        {
          key: 'VENDOR_NAME',
          label: 'Vendor Name',
          sortable: true,
          thClass: 'bg-head',
        },
        {
          key: 'EVENT_COUNT',
          label: 'Event Count',
          sortable: true,
          thClass: 'bg-head',
        },
        {
          key: 'EVENT_PARTICIPATED',
          label: 'Event Participated',
          sortable: true,
          thClass: 'bg-head',
        },
        {
          key: 'EVENT_AWARDED',
          label: 'Event Awarded',
          sortable: true,
          thClass: 'bg-head',
        },
      ],
    }
  },
  created() {
    const self = this
    self.$store.dispatch('toggleSidebar', false)
  },
  methods: {
    selectFrom(value) {
      let date = new Date(value)
      this.periodFrom = `${moment(date).format('YYYY-MM-DD')}`
    },
    selectTo(value) {
      let date = new Date(value)
      this.periodTo = `${moment(date).format('YYYY-MM-DD')}`
    },
    stopLoading() {
      this.isLoading = false
    },
    runLoading() {
      this.isLoading = true
    },
    async getEventData() {
      try {
        this.$ga.event({
          eventCategory: 'Dashboard Event',
          eventAction: 'click',
          eventLabel: `SUBMIT PERIOD_FROM=${this.periodFrom}&PERIOD_TO=${this.periodTo}${serverQuery}`,
        })
        await this.runLoading()
        const serverQuery =
          this.server !== 'ALL' ? `&SERVER=${this.server}` : ''
        const uri = `${api}/api/v1/dashboard/event?PERIOD_FROM=${this.periodFrom}&PERIOD_TO=${this.periodTo}${serverQuery}`
        const { data } = await axios({
          method: 'GET',
          url: uri,
        })
        if (data && data.status == 'success' && data.data) {
          this.items = data.data
          await this.stopLoading()
        } else {
          await this.stopLoading()
        }
      } catch (error) {
        await this.stopLoading()
      }
    },
    widthHeadTable(field) {
      switch (field) {
        case 'SERVER':
          return '10vw'
        case 'VENDOR_NAME':
          return '60vw'
        case 'EVENT_COUNT':
          return '10vw'
        case 'EVENT_PARTICIPATED':
          return '10vw'
        case 'EVENT_AWARDED':
          return '10vw'
        default:
          return '500px'
      }
    },
  },
}
</script>

<style lang="scss">
@import '~/assets/scss/components/dashboardevent.scss';
</style>
